import { ContainerTI, Card, Quantity, Graphic } from './styles';
import { Props } from './types';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Tooltip, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import BasicLineSetStyle from '../../../../graphics/BasicLineSetStyle';
import { loadRequest } from '../../../../../../store/ducks/kpiSE/actions';
import moment from 'moment';
import React from 'react';
import DetalhesOcorrencia from '../../modalDetalhesOcorrencia';

const KPI: React.FC<Props> = ({ cdd, inscricao }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const dispatch = useDispatch();
  const { Option } = Select;
  const loading = useSelector((state: ApplicationState) => state?.KPISE?.loading);
  const data = useSelector((state: ApplicationState) => state?.KPISE?.data[0]);
  const [date, setDate] = React.useState(7);

  React.useEffect(() => {
    dispatch(loadRequest(cdd, inscricao, moment().subtract(7, 'days').format(), 'SE', 1));
    localStorage.setItem('filterkpiSE', moment().subtract(7, 'days').format());
  }, [cdd, dispatch, inscricao]);

  const handleDate = (value: number) => {
    setDate(value);
    dispatch(loadRequest(cdd, inscricao, moment().subtract(value, 'days').format(), 'SE', 1));
    localStorage.setItem('filterkpiSE', moment().subtract(value, 'days').format());
  };

  return (
    <Card key={data?.card} className="themeSLA">
      <DetalhesOcorrencia
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        protocolos={data?.protocolos}
      />
      <ContainerTI className="containerTI">
        <div className="ti">
          <h2 className="title">{data?.card}</h2>
          <span className="info">
            <Tooltip
              title={`Todos os atendimentos onde ao menos um dos tempos determinados de SLA não foi cumprido no prazo de ${date} dias.`}
            >
              <InfoCircleOutlined role="tooltip" style={{ cursor: 'pointer' }} />
            </Tooltip>
          </span>
        </div>
        <Quantity onClick={() => setIsModalOpen(true)}>
          <p>{!loading ? data?.total?.toString()?.padStart(2, '0') : <LoadingOutlined />}</p>
          <p>
            {!loading ? (
              data?.percentual && data?.percentual?.toString()?.padStart(2, '0') + '%'
            ) : (
              <LoadingOutlined />
            )}
          </p>
        </Quantity>
      </ContainerTI>

      <Graphic>
        <BasicLineSetStyle data={data?.data} />
      </Graphic>

      <Select
        bordered={false}
        defaultValue={7}
        style={{ width: '100%', marginTop: '20px 0', fontWeight: 'bold', background: '#F1F1F1' }}
        onChange={handleDate}
      >
        <Option value={7}>Últimos 7 dias</Option>
        <Option value={15}>Últimos 15 dias</Option>
        <Option value={30}>Últimos 30 dias</Option>
      </Select>
    </Card>
  );
};

export default KPI;
